import "react-querybuilder/dist/query-builder.scss";

import React from "react";
import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";

import IndexPage from "./IndexPage";
import SamplePage from "./SamplePage";
import VariantsPage from "./VariantsPage";
import SamplesPage from "./SamplesPage";
import ColumnsPage from "./ColumnsPage";

import Modals from "../components/Modals";
import useRouteMatch from "../components/useRouteMatch";

function Navigation({ admin, variants }) {
  const routeMatch = useRouteMatch(["/", "/samples", "/columns", "/variants"]);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Tabs value={currentTab}>
      <Tab label="Overview" value="/" component="a" href={window.basename} />
      {variants ? (
        <Tab
          label="Variants"
          value="/variants"
          component={NavLink}
          to={window.basename + "variants"}
        />
      ) : (
        ""
      )}
      {admin ? (
        <Tab
          label="Samples"
          value="/samples"
          component={NavLink}
          to={window.basename + "samples"}
        />
      ) : (
        ""
      )}
      {admin ? (
        <Tab
          label="Columns"
          value="/columns"
          component={NavLink}
          to={window.basename + "columns"}
        />
      ) : (
        ""
      )}
    </Tabs>
  );
}

class Client extends Modals {
  constructor(props) {
    super(props);
    this.state["tab"] = ["/samples", "/columns", "/variants"].indexOf(
      location.pathname.replace(window.basename, "")
    );
    this.variants = document.querySelector("body").dataset.variants == "Yes";
    this.admin = document.querySelector("body").dataset.admin !== "False";
  }

  render() {
    return this.modalsWrapper(
      <BrowserRouter>
        <div className={"application"}>
          <nav className={"nav-panel"}>
            <Navigation admin={this.admin} variants={this.variants} />
          </nav>
          <div className={"app-content"}>
            <Routes>
              <Route
                path={window.basename}
                element={<IndexPage that={this} />}
              />
              <Route
                path={window.basename + "sample/:id"}
                element={<SamplePage that={this} />}
              />
              <Route
                path={window.basename + "samples"}
                element={<SamplesPage that={this} />}
              />
              <Route
                path={window.basename + "columns"}
                element={<ColumnsPage that={this} />}
              />
              <Route
                path={window.basename + "variants"}
                element={<VariantsPage that={this} />}
              />
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default Client;
